import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { Condition } from '../../../common/Condition';
import searchFormConditionsValues from '../../../../../defaultData/searchFormConditionsValues';
import {
  chipsStyles,
  FiltersOptionsWrapper,
  RangeFilterWrapper
} from '../styled';
import { FiltersSection } from '../FiltersSection';
import { RangeFilter } from '../../../../ui/RangeFilter';
import { Chips } from '../../../../ui/Chips';
import { PriceTitle } from './styled';
import { CurrencySymbol } from '../../../../ui/ItemCard/CurrencySymbol';
import { RangeFilterWithOptionsContainer } from '../../styled';

const units = <CurrencySymbol currency="AZN" />;

export const NewSearchPrice = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const valueHasMortgage = values.has_mortgage;
  const valueHasBillOfSale = values.has_bill_of_sale;

  const priceTitle = (
    <PriceTitle>
      {`${t('new_search.price')}, `}
      {units}
    </PriceTitle>
  );

  return (
    <FiltersSection title={priceTitle}>
      <RangeFilterWithOptionsContainer>
        <RangeFilterWrapper>
          <RangeFilter
            minName="price_from"
            minId="new-search-form-price-from"
            maxId="new-search-form-price-to"
            maxName="price_to"
            rangeInFilterModal
          />
        </RangeFilterWrapper>
        <Condition
          targetFieldName="leased"
          acceptedFieldValues={searchFormConditionsValues.has_bill_of_sale}
          fieldNamesToDisplay={['has_bill_of_sale', 'has_mortgage']}
        >
          <FiltersOptionsWrapper>
            <Chips
              type="button"
              hasCustomOnChange
              value={true}
              storedValue={valueHasBillOfSale}
              text={t('search.form.has_bill_of_sale')}
              onClick={() => change('has_bill_of_sale', !valueHasBillOfSale)}
              styles={chipsStyles}
              stat="new-search-form-has-bill-of-sale"
            />
            <Chips
              type="button"
              hasCustomOnChange
              value={true}
              storedValue={valueHasMortgage}
              text={t('search.form.has_mortgage')}
              onClick={() => change('has_mortgage', !valueHasMortgage)}
              styles={chipsStyles}
              stat="new-search-form-has-mortgage"
            />
          </FiltersOptionsWrapper>
        </Condition>
      </RangeFilterWithOptionsContainer>
    </FiltersSection>
  );
};
